module.exports = __webpack_public_path__ + "static/media/instagram.cfaf4397.png";